<template>
<div id="app">
  <header>
    <page-header></page-header>
  </header>

  <div class="updater">
    <updater></updater>
  </div>

  <div class="main-content">
    <transition name="fade-short">
      <div v-if="dataCenters.length > 0 && servers.length > 0"
          class="generic-wrapper"
          key="data">
        <div class="global-services">
          <span class="global-services__header"
                :class="{
                  'global-services__header--online': globalServices.filter(s => s.status === 'Online').length >= 2,
                  'global-services__header--partial': globalServices.filter(s => s.status === 'Online').length === 1,
                  'global-services__header--offline': globalServices.filter(s => s.status === 'Online').length === 0,
                }">
            <span class=text>Global Services</span>
          </span>
          <server v-for="(server, index) in globalServices" 
                  :server="server" 
                  :key="index" 
                  :congestion-badge="false" 
                  :creation-badge="false">
          </server>
        </div>

        <div class="region-wrapper">
          <div v-for="(region, index) in regions"
              :key="index" 
              :class="`region region--${region.toLowerCase().replace(' ', '-')}`">
            <span class="region__name">
              <span class=text>{{ region }}</span>
            </span>

            <div class="data-centers">
              <data-center v-for="(dataCenter, index) in dataCenters.filter(d => d.region === region)"
                          :key="index" 
                          :data-center="dataCenter" 
                          :servers="servers.filter(s => s.data_center ? s.data_center.name === dataCenter.name : false)">
              </data-center>
            </div>
          </div>
        </div>
      </div>
      
      <div v-else class="loader-wrapper" key="loader">
        <loader></loader>
      </div>
    </transition>

    <toast-queue></toast-queue>
  </div>

  <footer>
    <page-footer></page-footer>
  </footer>
</div>
</template>

<script>
import DataCenter from './components/DataCenter'
import Loader from './components/Loader'
import { mapGetters } from 'vuex'
import PageFooter from './components/Footer'
import PageHeader from './components/Header'
import Server from './components/Server'
import ToastQueue from './components/ToastQueue'
import Updater from './components/Updater'

export default {
  name: 'app',
  components: {
    DataCenter,
    Loader,
    PageFooter,
    PageHeader,
    Server,
    ToastQueue,
    Updater
  },

  data() {
    return {    
      regions: [
        'North America',
        'Europe',
        'Japan',
        'Oceania'
      ]
    }
  },

  computed: {
    ...mapGetters({
      'globalServices': 'getGlobalServices',
      'dataCenters': 'getDataCenters',
      'servers': 'getServers'
    })
  }
}
</script>

<style lang="scss" type="text/scss">

* {
  box-sizing: border-box;
}

html {
  font-size: 1em;
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
  color: $color-white;
  background-color: $color-dark-1;
  font-family: $font-roboto;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

header {
  flex-shrink: 0;
}

footer {
  flex-shrink: 0;
}

.main-content {
  padding-top: em(64px);
  flex-grow: 1;
}

.updater {
  z-index: 5;
  position: fixed;
  top: 0;
  width: 100%;
}

.loader-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.generic-wrapper {
  padding: em(10px);
}

.global-services {
  margin: em(10px) auto em(50px) auto;
  width: em(300px);
  max-width: em(300px);
  background-color: $color-dark-1;
}

.global-services__header {
  display: block;
  font-family: 'Roboto Slab', Helvetica, Arial, sans-serif;
  text-align: center;
  padding: em(10px);
  border-bottom: em(5px) solid $color-dark-1;
  border-color: $color-dark-1;
  transition: border-color 2s ease;

  .text {
    font-size: em(21px);
  }
}

.global-services__header--online {
  border-color: $color-online !important;
}

.global-services__header--partial {
  border-color: $color-maintenance !important;
}

.global-services__header--offline {
  border-color: $color-online !important;
}

.region-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.region {
  position: relative;
  margin-bottom: em(50px);
}

.region__name {
  display: block;
  font-family: $font-roboto-slab;
  text-align: center;

  .text {
    font-size: em(21px);
  }
}

.data-centers {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

//------- Transitions ----------

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease;
}

.fade-short-enter-active, .fade-short-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter, .fade-leave-to,
.fade-short-enter, .fade-short-leave-to {
  opacity: 0;
}
</style>
